export var DrivingSystem;
(function (DrivingSystem) {
    DrivingSystem["FOUR"] = "FOUR";
    DrivingSystem["FRONT"] = "FRONT";
    DrivingSystem["REAR"] = "REAR";
})(DrivingSystem || (DrivingSystem = {}));
